import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const anyOtherGlandularOrHormonalDisorder: AnswerPathTreeNode = {
  path: 'anyOtherGlandularOrHormonalDisorder',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredAnyOtherGlandularOrHormonalDisorderDetails }],
};
